<template>
  <div class="c3-custom-chart">
    <div v-bind:id="chartIdString" :ref="chartIdString"></div>
  </div>
</template>



<script>
  //////////////////////////////////////
  // Import of libraries
  //////////////////////////////////////
  import * as c3 from 'c3';

  //////////////////////////////////////
  // Vue Object
  //////////////////////////////////////
  export default {
    name: 'ChartCustom',
    props: {
      chartId: {
        type: String,
      },
      chartSettings: {
        type: Object,
        default: {},
      },
      allowResize: {
        type: Boolean,
        default: true,
      },
      dimensions: {
        type: Object,
      }
    },
    data() {
      return {
        id: false,
        chart: false,
        size: {}
      }
    },
    computed: {
      /**
       *  Sets the chart binding to the element contained within this component by the component's unique ID.
       *  Chart Settings that are passed in as a prop, will be added to the chart's final config.
       */
      chartConfig() {
        return {
          bindto: `#${this.chartIdString}`,
          ...this.chartSettings,
          size: this.size,
        };
      },
      chartIdString() {
        return `chart${this.id}`;
      },
    },
    watch: {
      // If the settings for the chart change, re-generate.
      chartConfig: {
        deep: true,
        handler() {
          this.renderChart();
        },
      },
    },
    beforeMount() {
      // If a custom ID was passed in, use that, else use this component's unique generated ID.
      this.id = this.chartId || this._uid;
      this.size = this.dimensions || {};
    },
    methods: {
      renderChart() {
        c3.generate(this.chartConfig);
      },
      handleResize() {
        if (this.allowResize) {
          this.size.width = this.$refs[this.chartIdString].clientWidth;
          this.size.height = this.$refs[this.chartIdString].clientHeight;
        }
        this.renderChart();
      },
    },
    mounted() {
      if (this.allowResize) {
        window.addEventListener('resize', this.handleResize);
      }
      this.$nextTick(() => {
        // Generate the chart
        this.handleResize();
      });
    },
    beforeDestroy() {
      if (this.allowResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }
</script>
